import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function ThankYou() {
  const navigate = useNavigate();
  const { testId } = useParams();

  useEffect(() => {
    // 🔒 Block back navigation
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = () => {
      navigate(`/intern-test/${testId}/thank-you`, { replace: true });
    };

    // ⏳ Auto redirect to Botervue website after 5 seconds
    const redirectTimer = setTimeout(() => {
      window.location.href = "https://botervuesystem.online";
    }, 5000); // 5 seconds

    return () => {
      window.onpopstate = null;
      clearTimeout(redirectTimer);
    };
  }, [navigate, testId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-10 rounded shadow text-center">
        <h1 className="text-2xl font-bold mb-4">🎉 Test Submitted!</h1>
        <p className="mb-2">Thank you for participating.</p>
        <p className="mb-4">
          Our team will contact shortlisted candidates.
        </p>
        <p className="text-sm text-gray-500">
          Redirecting you to Botervue in a few seconds…
        </p>
      </div>
    </div>
  );
}
